import { API_BASE_URL } from '../config/api';
import { parseApiResponse } from './apiHelpers';

const BASE = `${API_BASE_URL}/courses`;
const ENROLLMENT_BASE = `${API_BASE_URL}/enrollments`;
const STATS_BASE = `${API_BASE_URL}/users`;

export const fetchPlatformStats = async () => {
  const res = await fetch(`${STATS_BASE}/stats`);
  const data = await parseApiResponse(res);
  return data.data;
};

export const fetchCourses = async () => {
  const res = await fetch(BASE);
  const data = await parseApiResponse(res);
  return data.data;
};

export const fetchCourseBySlug = async (slugOrId) => {
  const res = await fetch(`${BASE}/${slugOrId}`);
  const data = await parseApiResponse(res);
  return data.data;
};

/** @deprecated use fetchCourseBySlug */
export const fetchCourseById = fetchCourseBySlug;

export const createCourse = async ({ title, description, duration, level }, authHeaders) => {
  const res = await fetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders },
    body: JSON.stringify({ title, description, duration, level }),
  });
  const data = await parseApiResponse(res);
  return data.data;
};

export const deleteTeacherCourse = async (courseId, authHeaders) => {
  const res = await fetch(`${BASE}/${courseId}`, {
    method: 'DELETE',
    headers: authHeaders,
  });
  return parseApiResponse(res);
};

/** Admin moderation: approve/reject and hide/unhide a course. */
export const moderateCourse = async (courseId, { status, is_hidden }, authHeaders) => {
  const res = await fetch(`${BASE}/${courseId}/moderation`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authHeaders },
    body: JSON.stringify({ status, is_hidden }),
  });
  const data = await parseApiResponse(res);
  return data.data;
};

export const fetchTeacherCourses = async (authHeaders) => {
  const res = await fetch(`${BASE}/my`, { headers: authHeaders });
  const data = await parseApiResponse(res);
  return data.data;
};

export const fetchCourseStudents = async (courseId, authHeaders) => {
  const res = await fetch(`${BASE}/${courseId}/students`, { headers: authHeaders });
  const data = await parseApiResponse(res);
  return data.data;
};

export const fetchMyStudents = async (authHeaders) => {
  const res = await fetch(`${BASE}/my/students`, { headers: authHeaders });
  const data = await parseApiResponse(res);
  return data.data;
};

export const enrollInCourse = async (courseId, authHeaders) => {
  const res = await fetch(`${ENROLLMENT_BASE}/${courseId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders },
  });
  return parseApiResponse(res);
};

export const fetchMyEnrollments = async (authHeaders) => {
  const res = await fetch(`${ENROLLMENT_BASE}/my`, { headers: authHeaders });
  const data = await parseApiResponse(res);
  return data.data;
};

export const unenrollFromCourse = async (courseId, authHeaders) => {
  const res = await fetch(`${ENROLLMENT_BASE}/${courseId}`, {
    method: 'DELETE',
    headers: authHeaders,
  });
  return parseApiResponse(res);
};
